/**
 * StudentTutoringScreen — l'onglet « Messages » de l'espace élève (patron A).
 *
 * Fil seul : la relecture du compte (`useStudentTutoringData`), le view-model
 * (`studentTutoringViewModel` : tuteurs et non-lus, l'état sans tuteur, l'offre ou la pause), les
 * gestes (`useStudentTutoringState`) → `<StudentCoachPage>`. Remplace
 * `student/tutoring/MyCoachTabScreen.js`, interrupteur allumé. Ses prochains lives ont quitté
 * l'onglet (Wajih, 18/10) : ils sont sur l'accueil et dans « Tous mes lives ».
 *
 * Au large, la page est le volet gauche de `<StudentCoachTwoPane>`, la conversation du tuteur
 * touché dans le volet droit (`StudentTutoringTwoPane`, du lot Messagerie) ; sur un téléphone, la
 * page seule, et le toucher d'un tuteur pousse `messenger`, comme aujourd'hui.
 */
import React from "react"
import { useSelector } from "react-redux"

import { studentTutoringViewModel } from "../../../../view-models/student/Tutoring/studentTutoringViewModel"
import { StudentTutoringTwoPane } from "../Messaging/StudentTutoringTwoPane"
import { useStudentTutoringData } from "./useStudentTutoringData"
import { useStudentTutoringState } from "./useStudentTutoringState"

export function StudentTutoringScreen() {
    // Pas de bouton « rafraîchir » dans l'espace élève (Wajih, 19/10) : la relecture du compte se fait
    // au retour sur l'onglet et au retour de l'app au premier plan.
    useStudentTutoringData()
    const vm = useSelector(studentTutoringViewModel)
    const actions = useStudentTutoringState({ mainTutorId: vm.mainTutorId })

    return (
        <StudentTutoringTwoPane
            mainTutorId={vm.mainTutorId}
            onOpenMessagesOnPhone={actions.openMessages}
            coach={{
                tutors: vm.tutors,
                noTutor: vm.noTutor,
                onStartTrial: vm.offer?.kind === "trial" ? actions.startTrial : undefined,
                onAskQuestion: vm.offer?.kind === "paused" ? actions.askQuestion : undefined,
                pausePeriod: vm.offer?.kind === "paused" ? vm.offer.pausePeriod : undefined,
            }}
        />
    )
}
